import * as PassengersDetails from './components/PassengersDetails/PassengersDetails.css';
import * as Disabilities from './components/Disabilities/Disabilities.css';
import * as Passenger from './components/Passenger/Passenger.css';
import * as PassengersDetailsModal from './components/PassengersDetailsModal/PassengersDetailsModal.css';
export default {
    PassengersDetailsModal,
    PassengersDetails,
    Disabilities,
    Passenger
};
